import { Html } from "@react-three/drei";

export default function LoadingScreen({ progress }) {
  return (
    <Html center className="loader-html">
      <div className="spinner-container">
        <div className="spinner">
          <div className="spinner-dot" />
        </div>
        <p className="spinner-text">{progress}% loaded</p>
      </div>
    </Html>
  );
}
